import { Table, TableBody } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import UOAModal from '../../../../components/Modals/UOAModal/UOAModal';
import { paginate } from '../../utils';
import UOAMobileFilters from '../UOAMobileFilters';
import MobileViewRowCells from './mobileViewRowCells';
import TableFooterCalendar from './tableFooterCalendar';
import UOATableHead from './UOATableHead';

const UOAMobileView = ({
  styles,
  setFilters,
  setStateAction,
  orderBy,
  order,
  loadUOAData,
  isMobile,
  sortData,
  getFilters,
  accessLevel,
}) => {
  const state = useSelector((state) => state.UOAState);

  return (
    <div>
      <UOAMobileFilters
        styles={styles}
        state={state}
        setFilters={(data) => setFilters(data)}
        handleCloseModal={() => setStateAction({ showModal: false })}
        getFilters={getFilters}
      />

      <div style={styles.selectstock}>Select a Stock</div>
      <Table size="small">
        <UOATableHead
          state={state}
          styles={styles}
          orderBy={orderBy}
          order={order}
          sortData={(data) => sortData(data)}
        />
        <TableBody>
          {paginate(
            [].slice.call(state.localUOA).sort((a, b) => {
              if (
                !orderBy ||
                (!(
                  typeof a[orderBy] === 'number' ||
                  typeof a[orderBy] === 'string'
                ) &&
                  // eslint-disable-next-line no-self-compare
                  typeof a[orderBy] === typeof a[orderBy])
              )
                return 0;

              if (typeof a[orderBy] === 'number')
                return order === 'desc'
                  ? a[orderBy] - b[orderBy]
                  : b[orderBy] - a[orderBy];
              else {
                return order === 'desc'
                  ? a[orderBy].localeCompare(b[orderBy])
                  : b[orderBy].localeCompare(a[orderBy]);
              }
            }),
            state.rowsPerPage,
            state.page
          ).map((row, index) => (
            <MobileViewRowCells
              index={index}
              setStateAction={(data) => setStateAction(data)}
              styles={styles}
              row={row}
            />
          ))}
        </TableBody>
        <TableFooterCalendar
          styles={styles}
          state={state}
          accessLevel={accessLevel}
          isMobile={isMobile}
          setStateAction={(data) => setStateAction(data)}
          rowsPerPage={state.rowsPerPage}
          loadUOAData={loadUOAData}
        />
      </Table>
      {state.isVolClicked ? (
        <UOAModal
          accessLevel={accessLevel}
          isMobile={isMobile}
          isVolClicked={state.isVolClicked}
          handleModalClose={() => setStateAction({ isVolClicked: false })}
          modalRowData={state.modalRowData}
          date={state.date}
        ></UOAModal>
      ) : (
        ''
      )}
    </div>
  );
};
export default UOAMobileView;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/UOAMobileView.js